import { lazy } from "react";

export const LazyPrepopulationBackgroundRefetch = lazy(async () => ({
    default: (await import("./PrepopulationBackgroundRefetch"))
        .PrepopulationBackgroundRefetch
}));
